import React, {useContext, useEffect, useState} from "react";
import { Navigate } from "react-router-dom";
import API from "../API";
import {TEST_URL} from "../../config";
import Context from "../context";

export default function Tests() {

  const api = new API()
  const {mainState} = useContext(Context)
  const [tests, setTests] = useState([])
  const [testIstOpen, setTestIsOpen] = React.useState(false)
  const [testId, setTestId] = useState()

  useEffect(() => {
    const isDemo = !(mainState.isLoggedIn &&( mainState.type === "Admin" || mainState.type === "Editor"))
    api.getTests(isDemo).then(data => {
      setTests(data)
    })
  }, [])

  function openTest(id) {
    setTestIsOpen(true)
    setTestId(id)
  }

  const testsJsx = tests.map(item => {
    return (
        <div className="tests-container__item" key={item.id} onClick={() => openTest(item.id)}>{item.name}
          <p>{item.description}</p></div>
    )
  })

  const adminJsx = <div className="tests-background">
    <div className="tests-container">
      {testsJsx}
    </div>
  </div>

  return (
      <>
        {testIstOpen ? <Navigate to={TEST_URL + '/' + testId}/> :
            <>{adminJsx}</>
        }
      </>
  )

}